export const gravitacija = 90



// WEBPACK FOOTER //
// ./src/konstante.js